import { Injectable } from '@angular/core';
import { HttpModule } from './http.module';
import {
  RemoteApiError,
  RemoteApiErrorMessage,
  RemoteApiErrorSeverity,
} from './model';
import { HttpError, HttpRequestErrorHandler } from '../../../core';

@Injectable({
  providedIn: HttpModule,
})
export class HttpErrorHandler implements HttpRequestErrorHandler {
  onError(error: HttpError): HttpError {
    if (
      error &&
      error.responseError &&
      error.responseError.error &&
      typeof error === 'object'
    ) {
      if (typeof error.responseError.error === 'string') {
        const errorResponse = error.responseError.error;

        if (!errorResponse.includes('<html>')) {
          error.tag = error.responseError.error;
        } else {
          error.tag = new RemoteApiErrorMessage(
            '' + error.responseError.status,
            RemoteApiErrorSeverity.Error,
            error.responseError.statusText,
            null,
            null,
            null,
            null
          );
        }
      } else if (typeof error.responseError.error === 'object') {
        if (
          'detailedMessage' in error.responseError.error &&
          'status' in error.responseError.error
        ) {
          error.tag = RemoteApiError.fromJSON(error.responseError.error);
        } else if (
          /*'severity' in error.responseError.error &&*/ 'messages' in
          error.responseError.error
        ) {
          error.tag = RemoteApiError.fromJSON(error.responseError.error);
        } else if ('message' in error.responseError.error) {
          // If single message is provided
          error.tag = RemoteApiErrorMessage.fromJSON(error.responseError.error);
        } else if (
          'key' in error.responseError.error &&
          'defaultDescription' in error.responseError.error
        ) {
          error.tag = RemoteApiErrorMessage.fromJSON(error.responseError.error);
        }
      }
    }

    return error;
  }

  onRemoteServiceUnavailable(error: HttpError) {}
}
